import Modal from 'react-modal';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import { checkWhichIconMustToBeReturned, getParameter, getPermission, showMessageError } from '../../../classes/functions';
import './receipt.css';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { FaPen, FaEye, FaUser} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import HeaderListing from '../../../components/HeaderListing/index.js';
import TablePagination from '../../../components/TablePagination/index.js';
import StatusButton from '../../../components/StatusButton/index.js';
import PercentageBar from '../../../components/PercentageBar/index.js';

export default function ReceiptDocuments(){
  const [list, setList] = useState([]);
  const [termSearch, setTermSearch] = useState('');
  const [addressers, setAddressers] = useState([]);
  const [carrying, setCarrying] = useState(true);
  const [listStatus, setListStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [showSelectStatus, setShowSelectStatus] = useState(false);
  const [statusButtonWasClicked, setStatusButtonWasClicked] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouse_filter, setWarehouseFilter] = useState('');
  const [blockWarehouseReceipt] = useState(getParameter('BLOQUEIA_ARMAZEM_RECEBIMENTO'));
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [showAddressersModal, setShowAddressersModal] = useState(false);
  const timeToRefreshReceiptDocumentsList = getParameter("TEMPO_ATU_REC");
  
  let delay;
  function search(warehouse = warehouse_filter, status = selectedStatus) {
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      let data = {
        data: {
          termSearch: termSearch,
          warehouse_filter: warehouse,
          status: status || window.location?.href?.split("?status=")[1],
          page: page,
          qtdePage: qtdePage
        }
      };
  
      api.post("/api/receipt_documents/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdePage);

          setStatusButtonWasClicked(false);
          setShowSelectStatus(false);
          
          setCarrying(false);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }, 750);
  }

  function getWarehouses(){
    api.get("/api/warehouses/getList")
    .then((response) => {
        setWarehouses(response.data);
    }).catch((error) => {
      setCarrying(false);
      console.log(error);
      showMessageError(error.response.data);
    });
  }
  
  function getStatus(){
    api.get("/api/generics/getItens?table=2B")
    .then((response) => {
      response.data.map((data) => {
        data.checked = false;

        return data;
      });

      setListStatus(response.data);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }
  
  function getAddressersById(receiptDocumentID){
    api
    .get(`/api/recebimentos/${receiptDocumentID}/enderecadores`)
    .then((response) => {
      setAddressers(response.data);
      setShowAddressersModal(true);
    })
    .catch((error) => {
      console.log(error);
      
      if(error?.response?.data){
        showMessageError(error?.response?.data);
      };
    });
  }

  useEffect(() => {
    getStatus();
    getWarehouses();
    search();
  }, []);

  useEffect(() => {
    search();
  }, [qtdePage, page, termSearch]);

  useEffect(() => {
    if(statusButtonWasClicked){
      search();
    }
  }, [statusButtonWasClicked]);

  useEffect(() => {
    if(timeToRefreshReceiptDocumentsList && timeToRefreshReceiptDocumentsList !== "0"){
      setInterval(() => {
        search();
      }, parseInt(timeToRefreshReceiptDocumentsList) * 1000); 
    }
  }, [])

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <Modal
        isOpen={showAddressersModal}
        onRequestClose={() => setShowAddressersModal(false)}
        contentLabel="Endereçadores"
        className="modal-addressers"
      >
        <h2 className="modal-addressers__title">Endereçadores</h2>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
            </tr>
          </thead>
          <tbody>
            {addressers.map((addresser, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{addresser.enderecador}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button className="buttonSubmit modal-addressers__button" onClick={() => setShowAddressersModal(false)}>Fechar</button>
      </Modal>

      <HeaderListing name="Controle de Recebimento" url="/receipt_documents/cadastrar" permission="OPERACOES - CONTROLE RECEBIMENTOS - CADASTRO - DESATIVADO" carrying={carrying} search={search} itensByPage={qtdePage} setItensByPage={setQtdePage} termSearch={termSearch} setTermSearch={setTermSearch} pesquisa_status={pesquisa_status}>
        <div className="container">
            <table>
              <thead>
                <tr>
                  <th scope="col">
                    <StatusButton
                      showSelectStatus={showSelectStatus}
                      setShowSelectStatus={setShowSelectStatus}
                      listStatus={listStatus}
                      setListStatus={setListStatus}
                      selectedStatus={selectedStatus}
                      setSelectedStatus={setSelectedStatus}
                      setStatusButtonWasClicked={setStatusButtonWasClicked}
                    />
                  </th>
                  <th scope="col">Documento</th>
                  {blockWarehouseReceipt == 'T' && <th scope="col"><div className="formDiv">
                    <select value={warehouse_filter} onChange={(e) => {setWarehouseFilter(e.target.value); search(e.target.value)}}>
                      <option value="">Armazém Recebimento</option>
                      {warehouses.map((item, index) => (
                        <option key={index} value={item.id}>{item.descricao}</option>
                      ))}
                    </select>
                  </div></th>}
                  <th scope="col">Cliente/Fornecedor</th>
                  <th scope="col">Data</th>
                  <th scope="col">Aprovador</th>
                  <th scope="col">Endereçador</th>
                  <th scope="col">Transbordo</th>
                  <th scope="col">Observação</th>
                  <th scope="col" className='collumOption'>Opções</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td title={item.status} data-label="Status" id="td-status">
                        {checkWhichIconMustToBeReturned(item.status, "2.5rem")}
                        <PercentageBar currentPercentage={item.barra_progresso.porcentagem} />
                      </td>
                      <td data-label="Documento">{item.documento}</td>
                      {blockWarehouseReceipt == 'T' && <td data-label="Armazém Recebimento">{item.label_warehouse_receipt}</td>}
                      <td data-label="Cliente/Fornecedor">{item.cliente}</td>
                      <td data-label="Data">{item.data}</td>
                      <td data-label="Data">{item.aprovador}</td>
                      <td data-label="Data">
                        {item.enderecador &&
                          <div id="addressing-column">
                            <Link className="action" style={{color: "black"}} onClick={() => getAddressersById(item.id)}>
                              <FaUser size={19} />
                            </Link>
                            {item.enderecador}
                          </div>
                        }
                      </td>
                      <td data-label="Transbordo">{item.transbordo}</td>
                      <td data-label="Observação">{item.observacao}</td>
                      <td data-label="Opções">
                        {getPermission('OPERACOES - CONTROLE RECEBIMENTOS - CADASTRO') && <Link className="action" to={`/receipt_documents/cadastrar/u${item.id}`} >
                          <FaPen color="#000" size={17} />
                        </Link>}
                        <Link className="action" to={`/receipt_documents/cadastrar/v${item.id}`} >
                          <FaEye color="#000" size={19} />
                        </Link>
                      </td> 
                    </tr>
                  )
                })}
                {list.length == 0 && <tr>
                  <td colSpan={6}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>}
              </tbody>
            </table>
          </div>
          <br/>
          <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} pesquisa_status={pesquisa_status} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/receipt_documents/getSearch" params={{}}/>
      </HeaderListing>
    </div>
  )
}